
chartsController.$inject = ['$scope', '$mdDialog', 'metricData', 'previousBoxButtonsIds', 'previousBoxButtonsContent', 'displayCurrentBoxButtonsGraph',
  'currentBoxButtonsIds', 'currentBoxButtonsContent', 'displayPreviousBoxButtonsGraph'];
export function chartsController($scope, $mdDialog, metricData, previousBoxButtonsIds, previousBoxButtonsContent, displayCurrentBoxButtonsGraph,
  currentBoxButtonsIds, currentBoxButtonsContent, displayPreviousBoxButtonsGraph) {

  $scope.cancel = cancel;

  init();

  function init() {
    
    $scope.metricData = metricData ;
    $scope.previousBoxButtonsContent = previousBoxButtonsContent;
    $scope.displayCurrentBoxButtonsGraph = displayCurrentBoxButtonsGraph;
    $scope.currentBoxButtonsContent = currentBoxButtonsContent;
    $scope.displayPreviousBoxButtonsGraph = displayPreviousBoxButtonsGraph;
    $scope.dateRange = $scope.metricData.date_range;
    
    $scope.previousBoxButtonsClicks = [];
    for(var i = 0; i < previousBoxButtonsIds.length; i++){  
      $scope.previousBoxButtonsClicks.push([]);
    }

    $scope.currentBoxButtonsClicks = [];
    for(var i = 0; i < currentBoxButtonsIds.length; i++){  
      $scope.currentBoxButtonsClicks.push([]);
    }

    var maxClicksPreviousBoxButtons = 0;
    var maxClicksCurrentBoxButtons = 0;

    $scope.dateRange.forEach(function(date) {
      for(var i = 0; i < previousBoxButtonsIds.length; i++){
        const buttonId = previousBoxButtonsIds[i];
        var nClicks = 0;
        if ($scope.metricData.daily_clicks[buttonId] && $scope.metricData.daily_clicks[buttonId][date]) {
          nClicks = $scope.metricData.daily_clicks[buttonId][date];
          if (nClicks > maxClicksPreviousBoxButtons) maxClicksPreviousBoxButtons = nClicks;
        }
        $scope.previousBoxButtonsClicks[i].push(nClicks);
      }
      for(var i = 0; i < currentBoxButtonsIds.length; i++){
        const buttonId = currentBoxButtonsIds[i];
        var nClicks = 0;
        if ($scope.metricData.daily_clicks[buttonId] && $scope.metricData.daily_clicks[buttonId][date]) {
          nClicks = $scope.metricData.daily_clicks[buttonId][date];
          if (nClicks > maxClicksCurrentBoxButtons) maxClicksCurrentBoxButtons = nClicks;
        }
        $scope.currentBoxButtonsClicks[i].push(nClicks);
      }
    });
    
    $scope.datasetOverridePrevious = [{ yAxisID: 'y-axis-prev' },{fill: false}];
    $scope.optionsPrevious = {
      scales: {
        yAxes: [
          {
            id: 'y-axis-prev',
            type: 'linear',
            display: true,
            position: 'left',
            ticks: {
              min: 0,
              stepSize: Math.ceil(maxClicksPreviousBoxButtons / 4)
            }
          }
        ]
      },
      legend: {
        display: true,        
        position: 'right',
      }
    };

    $scope.datasetOverrideCurrent = [{ yAxisID: 'y-axis-current' },{fill: false}];
    $scope.optionsCurrent = {
      scales: {
        yAxes: [
          {
            id: 'y-axis-current',
            type: 'linear',
            display: true,
            position: 'left',
            ticks: {
              min: 0,
              stepSize: Math.ceil(maxClicksCurrentBoxButtons / 4)
            }
          }
        ]
      },
      legend: {
        display: true,        
        position: 'right',
      }
    };

  }

  function cancel() {
    $mdDialog.cancel();
  }

}
